export default __webpack_public_path__ + "static/media/donateBlood.1fbd16aa.svg";